module.exports = __webpack_public_path__ + "img/rubylogonew.84a43d72.png";